import { api } from './_request';

 export const get = (data) => {
 	return (dispatch) => {
		dispatch({
			type: 'INVENTARIO_FISICO_LIST',
			payload: data
		});
 	}
 };

 export const save = (item, callback) => {
	return (dispatch) => {

		dispatch({ type: 'SAVE' });

		api().post('/saveInvoice', item).then(function(response) {

			if(response.status === 200) {

				dispatch({
					type: 'SAVE_SUCCESS',
					payload: response.data.factura,
				});

				if(typeof callback === 'function') callback(response.data);

			}
			else{
				dispatch({ type: 'SAVE_FAILURE' });
			}

		})
		.catch(function(error) {
			dispatch({ type: 'SAVE_FAILURE' });
		});

	}
};

export const save_importacion = (item, callback) => {
	return (dispatch) => {

		dispatch({ type: 'SAVE' });

		api().post('/importacion_factura', item).then(function(response) {

			if(response.status === 200) {

				dispatch({
					type: 'SAVE_SUCCESS',
					payload: response.data
				});

				if(typeof callback === 'function') callback(response.data);

			}
			else{
				dispatch({ type: 'SAVE_FAILURE' });
			}

		})
		.catch(function(error) {
			dispatch({ type: 'SAVE_FAILURE' });
		});

	}
};

export const update_importacion = (item, callback) => {
	return (dispatch) => {

        
		dispatch({ type: 'SAVE' });

		api().post(`/importacion_factura/${item.id}`, item)
		.then(function(response)
		{
			if(response.status === 200)
			{
				dispatch({
					type: 'UPDATE_SUCCESS',
					payload: response.data
				});
				console.log('factura action----->', response.data);

				if(typeof callback === 'function') callback(response.data);
			}
			else
			{
				dispatch({ type: 'SAVE_FAILURE' });
			}
		})
		.catch(function(error) {
			dispatch({ type: 'SAVE_FAILURE' });
		});

	}
};

export const update_total = (item, callback) => {
	return (dispatch) => {

        
		dispatch({ type: 'SAVE' });

		api().post(`/full_update_factura/${item.id}`, item)
		.then(function(response)
		{
			if(response.status === 200)
			{
				console.log('factura action----->', response.data.factura);
				dispatch({
					type: 'UPDATE_SUCCESS',
					payload: response.data.factura
				});
				

				if(typeof callback === 'function') callback(response.data.factura);
			}
			else
			{
				dispatch({ type: 'SAVE_FAILURE' });
			}
		})
		.catch(function(error) {
			dispatch({ type: 'SAVE_FAILURE' });
		});

	}
};
export const timbrar = (factura) => {
	return (dispatch) => {

        
		dispatch({
					type: 'UPDATE_SUCCESS',
					payload: factura
				});
	}
};

export const actualizar_renglon = (factura) => {
	return (dispatch) => {

        
		dispatch({
					type: 'UPDATE_SUCCESS',
					payload: factura
				});
	}
};




export const alerta = (alerta) => {
	return (dispatch) => {
		dispatch({
				type: 'SAVE_ALERTA',
				payload: alerta
			});
	}
};

export const update = (item, callback) => {
	return (dispatch) => {

        
		dispatch({ type: 'SAVE' });

		api().post(`/factura/update/${item.id}`, item)
		.then(function(response)
		{
			if(response.status === 200)
			{
				console.log('factura action----->', response.data);
				dispatch({
					type: 'UPDATE_SUCCESS',
					payload: response.data.factura
				});
				

				if(typeof callback === 'function') callback(response.data);
			}
			else
			{
				dispatch({ type: 'SAVE_FAILURE' });
			}
		})
		.catch(function(error) {
			dispatch({ type: 'SAVE_FAILURE' });
		});

	}
};


// WEBPACK FOOTER //
// ./src/actions/factura.js